export const getMilestoneMessage = (timeLeft, totalTime, reminders = []) => {
  const customReminder = reminders.find(
    (reminder) => reminder.seconds === timeLeft
  );

  if (customReminder) return customReminder.message;

  if (totalTime > 300) {
    if (timeLeft === totalTime) return "Begin your test. You've got this!";
    if (timeLeft === Math.floor(totalTime / 2)) {
      return "Check your progress, time is halfway up.";
    }
    if (timeLeft === 300) {
      return "5 minutes left. Answer any skipped questions.";
    }
    if (timeLeft === 120) {
      return "2 minutes left. Make sure all questions have an answer & your name is on the paper.";
    }
    if (timeLeft === 0) return "Time is up. Please put your pencils down.";
  } else {
    if (timeLeft === totalTime) return "Begin your presentation.";
    if (timeLeft === Math.floor(totalTime / 2)) {
      return "You are halfway through your time.";
    }
    if (timeLeft === 30) {
      return "30 seconds left. Please wrap up your final thoughts.";
    }
    if (timeLeft === 0) return "Thank you, your time is up.";
  }

  return null;
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
    .toString()
    .padStart(2, '0')}`;
};